import { render, staticRenderFns } from "./nonProgress.vue?vue&type=template&id=229406a8"
import script from "./nonProgress.vue?vue&type=script&lang=js"
export * from "./nonProgress.vue?vue&type=script&lang=js"
import style0 from "./nonProgress.vue?vue&type=style&index=0&id=229406a8&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports